import * as React from 'react';

import { INewbuildingMapPin } from '../../types/map';
import { MapButton } from '../../components/NewbuildingsComparePage/parts/MapButton';
import { MobileMapButton } from '../../components/NewbuildingsCompareMobilePage/parts/MobileMapButton';
import type { TNewbuildingsMapPlatform } from '../../components/NewbuildingsMap';
import { NewbuildingsMapModal } from '../../components/NewbuildingsMapModal';
import { YANDEX_MAP_API_KEY_CONFIG_KEY } from '../../constants/map';
import { useApplicationContext } from '../../utils/applicationContext';
import { trackOpenMap, trackPinClick } from './tracking';

export interface INewbuildingsMapContainerProps {
  pins: INewbuildingMapPin[];
  platform?: TNewbuildingsMapPlatform;
}

export function NewbuildingsMapContainer({
  pins,
  platform = 'desktop',
}: INewbuildingsMapContainerProps): React.JSX.Element | null {
  const { config, logger } = useApplicationContext();
  const [isOpened, setOpenedState] = React.useState(false);

  const apiKey = config.get<string>(YANDEX_MAP_API_KEY_CONFIG_KEY);

  React.useEffect(() => {
    if (!apiKey) {
      logger.error('Не задан ключ Яндекс.Карт, карта в сравнении ЖК скрыта', {
        key: YANDEX_MAP_API_KEY_CONFIG_KEY,
      });
    }
  }, [apiKey, logger]);

  const handleOpen = React.useCallback(() => {
    setOpenedState(true);
    trackOpenMap(
      pins.map(pin => pin.newbuilding.id),
      platform,
    );
  }, [pins, platform]);

  const handleClose = React.useCallback(() => {
    setOpenedState(false);
  }, []);

  const handlePinClick = React.useCallback(
    (pin: INewbuildingMapPin) => {
      if (platform === 'desktop') {
        trackPinClick({ newbuildingId: pin.newbuilding.id, builderId: pin.newbuilding.builders[0]?.id });
      }
    },
    [platform],
  );

  if (!apiKey) {
    return null;
  }

  return (
    <>
      {platform === 'mobile' ? <MobileMapButton onClick={handleOpen} /> : <MapButton onClick={handleOpen} />}
      {isOpened && (
        <NewbuildingsMapModal
          apiKey={apiKey}
          pins={pins}
          platform={platform}
          onClose={handleClose}
          onPinClick={handlePinClick}
        />
      )}
    </>
  );
}
